import * as React from 'react';
import { useLayouts } from '../../hooks';
import { RoomTypeFilter, LayoutsCards } from './parts';
import { WidgetLayout } from './parts/WidgetLayout';
import { NotAvailableScreen } from './parts/NotAvailableScreen';
import { PaginationContainer } from './parts/Pagination/PaginationContainer/PaginationContainer';
import { OffersLinks } from './parts/OffersLinks';
import { useTracking } from '../../hooks/useTracking';
import { TrackingContext } from '../../shared/context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Layouts = _ref => {
  let {
    newbuildingId,
    houseId,
    roomsCountList,
    isHouseLayoutsAvailable,
    onHouseFilterReset,
    pageTypeJK,
    contactsButton,
    isQueryParamsEnabled
  } = _ref;
  const {
    layouts,
    roomType,
    onRoomTypeChange,
    isLoading,
    pagination,
    offersLinks
  } = useLayouts({
    newbuildingId,
    houseId,
    isHouseLayoutsAvailable,
    isQueryParamsEnabled
  });
  const tracking = useTracking({
    newbuildingId,
    pageTypeJK,
    houseId
  });
  const filterRef = React.useRef(null);

  // Для SEO страницы и обычной карточки 3 столбца, для фичеренговой 4
  const columnsNumber = React.useMemo(() => pageTypeJK === 'Featuring' ? 4 : 3, [pageTypeJK]);
  const columnsMaxWidth = React.useMemo(() => pageTypeJK === 'Featuring' ? 263 : 300, [pageTypeJK]);
  if (!isHouseLayoutsAvailable) {
    return /*#__PURE__*/_jsx(WidgetLayout, {
      children: /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset,
        title: "\u041D\u0435\u0442 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043E\u043A \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u0440\u043F\u0443\u0441\u0430"
      })
    });
  }
  if (layouts.length === 0 && !isLoading) {
    return /*#__PURE__*/_jsxs(WidgetLayout, {
      children: [/*#__PURE__*/_jsx(RoomTypeFilter, {
        roomsCountList: roomsCountList,
        onChange: onRoomTypeChange,
        value: roomType,
        ref: filterRef
      }), /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset,
        title: "\u0412 \u044D\u0442\u043E\u043C \u043A\u043E\u0440\u043F\u0443\u0441\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043E\u0442\xA0\u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430 \u043D\u0435\u0442"
      })]
    });
  }
  return /*#__PURE__*/_jsx(TrackingContext.Provider, {
    value: tracking,
    children: /*#__PURE__*/_jsxs(WidgetLayout, {
      children: [/*#__PURE__*/_jsx(RoomTypeFilter, {
        roomsCountList: roomsCountList,
        onChange: onRoomTypeChange,
        value: roomType,
        ref: filterRef
      }), /*#__PURE__*/_jsx(LayoutsCards, {
        layouts: layouts,
        isLoading: isLoading,
        columnsNumber: columnsNumber,
        columnsMaxWidth: columnsMaxWidth,
        contactsButton: contactsButton,
        newbuildingId: newbuildingId,
        houseId: houseId
      }), /*#__PURE__*/_jsx(PaginationContainer, {
        cardsRef: filterRef,
        onPageSelect: pagination.onPageChange,
        page: pagination.page,
        lastPage: pagination.lastPage
      }), !isLoading && /*#__PURE__*/_jsx(OffersLinks, {
        linksInfo: offersLinks,
        houseId: houseId,
        roomType: roomType
      })]
    })
  });
};